import React, { useMemo, useState } from "react";
import { ethers } from "ethers";
import getIcon from "../utils/Icon";

// Локальные ассеты — только базовые монеты; варианты (USDT0, WETH) сводим к ним.
const localTokenIcon = (symbol) => {
    const s = String(symbol || "").toUpperCase();
    if (s.startsWith("USDT")) return getIcon("USDT");
    if (s === "WETH" || s.startsWith("ETH")) return getIcon("ETH");
    return getIcon(s);
};

// Иконка по адресу контракта (сеть у нас одна — Arbitrum). Пути Trust Wallet
// требуют EIP-55 регистр, поэтому прогоняем через getAddress.
const cdnTokenIcon = (address) => {
    try {
        const a = ethers.getAddress(String(address || "").toLowerCase());
        return `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/arbitrum/assets/${a}/logo.png`;
    } catch {
        return null;
    }
};

// Каскад: локальный ассет → CDN по адресу → заглушка-кошелёк.
export default function TokenIcon({ symbol, address }) {
    const candidates = useMemo(
        () => [localTokenIcon(symbol), cdnTokenIcon(address), getIcon("wallet")].filter(Boolean),
        [symbol, address],
    );
    const [idx, setIdx] = useState(0);
    return (
        <img
            src={candidates[Math.min(idx, candidates.length - 1)]}
            alt={symbol || "token"}
            className="w-[20px] h-[20px] object-contain rounded-full"
            onError={() => setIdx((i) => i + 1)}
        />
    );
}
